import moment from "moment";
import PropTypes from "prop-types";
import { Button, DatePicker, Input, Select, SettingsCard, Space, Switch } from "top-component-library";
import { INACTIVE_CATEGORY_OPTIONS } from "../constants";
import { FormRow, SettingHint } from "../styles";

// Mirrors editCustomerProperties.html's "Customer Success" card.
const CustomerSuccessCard = ({
  customerName,
  currentlyMuted,
  inactiveCategory,
  closedReason,
  closedUntil,
  fullstory,
  onMute,
  onInactiveCategoryChange,
  onClosedReasonChange,
  onClosedUntilChange,
  onUnmuteAndSave,
  onFullstoryChange,
  onSave,
}) => (
  <SettingsCard title="Customer Success">
    <SettingHint>
      You can set a reason for this customer to be inactive (controls the category on the main customer chooser page).
    </SettingHint>
    <SettingHint>
      If you know {customerName} will be closed for a while, please set the reason to keep our dashboard accurate!
    </SettingHint>
    {!currentlyMuted && (
      <Button className="margin-top-2" onClick={onMute}>
        Mark inactive reason...
      </Button>
    )}
    {currentlyMuted && (
      <>
        <FormRow>
          <label htmlFor="customer-properties-inactive-category">Inactive reason</label>
          <Select
            id="customer-properties-inactive-category"
            value={inactiveCategory}
            onChange={onInactiveCategoryChange}
          >
            {INACTIVE_CATEGORY_OPTIONS.map((option) => (
              <Select.Option key={option} value={option}>
                {option}
              </Select.Option>
            ))}
          </Select>
        </FormRow>
        <FormRow>
          <label htmlFor="customer-properties-closed-reason">Details (optional)</label>
          <Input
            id="customer-properties-closed-reason"
            placeholder="reason"
            value={closedReason ?? ""}
            onChange={(event) => onClosedReasonChange(event.target.value)}
          />
        </FormRow>
        <FormRow>
          <label htmlFor="customer-properties-closed-until">Inactive til</label>
          <DatePicker
            id="customer-properties-closed-until"
            value={closedUntil ? moment(closedUntil) : null}
            onChange={(date) => onClosedUntilChange(date ? date.toISOString() : null)}
          />
        </FormRow>
        <Button type="primary" onClick={onSave}>
          Save
        </Button>
        <Button onClick={onUnmuteAndSave}>Mark active again</Button>
      </>
    )}
    <FormRow>
      <label htmlFor="customer-properties-fullstory">Fullstory Integration</label>
      <Space>
        <Switch
          id="customer-properties-fullstory"
          checked={fullstory}
          onChange={onFullstoryChange}
          aria-label="Enable Fullstory"
        />
        Full Story Session Tracking
      </Space>
    </FormRow>
  </SettingsCard>
);

CustomerSuccessCard.propTypes = {
  customerName: PropTypes.string.isRequired,
  currentlyMuted: PropTypes.bool.isRequired,
  inactiveCategory: PropTypes.string,
  closedReason: PropTypes.string,
  closedUntil: PropTypes.string,
  fullstory: PropTypes.bool.isRequired,
  onMute: PropTypes.func.isRequired,
  onInactiveCategoryChange: PropTypes.func.isRequired,
  onClosedReasonChange: PropTypes.func.isRequired,
  onClosedUntilChange: PropTypes.func.isRequired,
  onUnmuteAndSave: PropTypes.func.isRequired,
  onFullstoryChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

CustomerSuccessCard.defaultProps = {
  inactiveCategory: undefined,
  closedReason: "",
  closedUntil: null,
};

export default CustomerSuccessCard;
